module.exports = __webpack_public_path__ + "static/media/Drug-Law.56451724.jpg";